import { ThemedLogo } from "../ui/themedLogo";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-global-secondary px-4 sm:px-6 py-5 sm:py-6">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6">
        <div className="flex items-center gap-3 sm:gap-4">
          <ThemedLogo className="h-10 sm:h-12 w-auto object-contain" />
          <span className="text-global-muted">·</span>
          <span className="text-size-sm text-global-tertiary font-medium">
            Sistema de gestión
          </span>
        </div>
        <p className="text-size-sm text-global-muted shrink-0">
          © {currentYear} DashCore AI. Todos los derechos reservados.
          <span className="ml-2 text-global-muted/70">
            · v{__APP_VERSION__}
          </span>
        </p>
      </div>
    </footer>
  );
};
